<script setup>
import { toRef, computed, useAttrs } from 'vue';
import { useChannelIcon, useChannelColor } from './provider';

const props = defineProps({
  inbox: {
    type: Object,
    required: true,
  },
});

// TODO: modificado por Ublux
defineOptions({ inheritAttrs: false });

const attrs = useAttrs();
const channelIcon = useChannelIcon(toRef(props, 'inbox'));
const channelColor = useChannelColor(toRef(props, 'inbox'));

const brandStyle = computed(() => {
  const { text, gradient } = channelColor.value;
  if (gradient) return { backgroundImage: text };
  return { color: text };
});

const mergedStyle = computed(() => {
  const parentStyle = attrs.style || {};
  return [brandStyle.value, parentStyle];
});

const mergedClass = computed(() => [channelIcon.value, attrs.class]);
</script>

<template>
  <span :class="mergedClass" :style="mergedStyle" />
</template>
